import * as React from 'react';
import Theme from '../../../styles/Theme/Theme';
import * as IconsLibrary from './Library';

type TCustomIconProps = {
    icon: IconsLibrary.LibraryTypes;
    customColor?: keyof typeof Theme.color;
}

type TProps = TCustomIconProps & React.CSSProperties

const CustomIcon = ({ icon, ...rest }: TProps) => {
    if (icon) {
        let Component = IconsLibrary[icon] as React.ElementType;

        if (Component && typeof Component !== 'undefined') {
            return <Component {...rest} />;
        }

        console.error('ERROR: SVG icon (' + icon + ') does not exist');
        return null;
    }

    console.error('ERROR: icon props is missing');
    return null;
};

export default CustomIcon;
